import PropTypes from 'prop-types';
import React, { createContext, useContext, useState } from 'react';

const TenantContext = createContext();

export const TenantProvider = ({ children }) => {
  const [tenant, setTenant] = useState({
    tenantId: '',
    tenantKey: '',
    tenantName: '',
    tenantTitle: '',
    tabDetails: null,
    loginPermissions: [],
    isSuperAdmin: false,
    hideUserId: false,
    hideInternalUser: false,
    whetherCallIESUser: false,
    subTypeConfig: [],
    proxyTenant: false,
    defaultEntityTypes: null,
    defaultAllBooksType: null,
    defaultFeedbackAllBooksType: null,
    apiConfig: {},
    otel: null,
    currentTabName: ''
  });

  return <TenantContext.Provider value={{ tenant, setTenant }}>{children}</TenantContext.Provider>;
};

TenantProvider.propTypes = {
  children: PropTypes.node.isRequired
};

// Custom hook for consuming the context
export const useTenant = () => useContext(TenantContext);
